import React from 'react'
import PageNotFoundPage from '../parts/pages/PageNotFoundPage'

export default function PageNotFound() {
  return <PageNotFoundPage />
}
